<template>
  <div class="box" style="width: 70px;height: 570px; position: absolute; top: 41%;  left: 60%;  transform: translate(-50%, -50%);  margin: 0;">
    <div class="butL" @click="butLclick">
      <img alt="Logo" src="../assets/leftbutton.png" style="height: 60px;"/>
    </div>
    <div class="butR" style="  position: absolute;
  top: 20%;
  margin-top: -20px;
  z-index: 999;
  cursor: pointer;
  right: -455px;" @click="butRclick">
      <img alt="Logo" src="../assets/rightbutton.png" style="height: 60px;"/>
    </div>
  </div>
  <div class="dbeijing" style="background-image: url('jiancai.webp'); width: 100vw;  height: 100vh;  position: fixed;  top: 0;  left: 0%;  z-index: -1;  background-size: 100% 100%;  background-position: center center; background-repeat: no-repeat;">
    <div style="font-size: 33px;width: 100%;position: fixed; left: 50%;top: 15%;  transform: translate(-50%, -50%);  text-align: center;  pointer-events: none;z-index: 999;color: white">
      <h1>建材选购</h1>
      <div class="hidden-column">
      <div style="display:flex;position: absolute;left: 50%;transform: translate(-50%);z-index: 999;margin-top: 10px">
      <div  @click="butLclick" style="margin-right: 40px;z-index: 999; pointer-events: auto;">
        <img alt="Logo" src="../assets/leftbutton.png" style="height: 55px;"/>
      </div>
      <div  @click="butRclick" style=" pointer-events: auto;">
        <img alt="Logo" src="../assets/rightbutton.png" style="height: 50px;"/>
      </div>
      </div>
      </div>
    </div>
    <div class="jiancailist" style="position: fixed;top: 30%;left: 10%;transform-origin: left top;transform: scale(1);">
      <div v-if="index==0" >
        <div class="block14box">
        <div class="block_14 flex-row">
          <span class="text_20">01</span> <span class="text_21">/10</span>
          <span class="text_22" style="margin-left: 120px;">瓷砖</span>
          <div class="blocks_16 flex-row"></div>
          <div class="blocks_17 flex-row"></div>
          <div class="blocks_18 flex-row"></div>
        </div>
        <div class="block_14 flex-row" style="margin-top: 40px">
          <span class="text_20">02</span> <span class="text_21">/10</span>
          <span class="text_22" style="margin-left: 120px">门窗</span>
          <div class="block_19 flex-row"></div>
          <div class="block_20 flex-row"></div>
          <div class="block_21 flex-row"></div>
        </div>
        </div>
      </div>
      <div v-if="index==1" >
        <div class="block14box">
        <div class="block_14 flex-row" >
          <span class="text_20">03</span> <span class="text_21">/10</span>
          <span class="text_22" style="margin-left: 120px">基础建材</span>
          <div class="block_6 flex-row"></div>
          <div class="block_7 flex-row"></div>
          <div class="block_8 flex-row"></div>
        </div>
        <div class="block_14 flex-row" style="margin-top: 40px">
          <span class="text_20">04</span> <span class="text_21">/10</span>
          <span class="text_22" style="margin-left: 120px">灯具开关</span>
          <div class="blocks_0 flex-row"></div>
          <div class="blocks_1 flex-row"></div>
          <div class="blocks_2 flex-row"></div>
        </div>
        </div>
      </div>
      <div v-if="index==2" >
        <div class="block14box">
        <div class="block_14 flex-row">
          <span class="text_20">05</span>
          <span class="text_21">/06</span>
          <span class="text_22" style="margin-left: 120px">家电</span>
          <div class="blocks_3 flex-row"></div>
          <div class="blocks_4 flex-row"></div>
          <div class="blocks_5 flex-row"></div>
        </div>
        <div class="block_14 flex-row" style="margin-top: 40px">
          <span class="text_20">06</span> <span class="text_21">/10</span>
          <span class="text_22" style="margin-left: 120px">卫浴</span>
          <div class="blocks_6 flex-row"></div>
          <div class="blocks_7 flex-row"></div>
          <div class="blocks_8 flex-row"></div>
        </div>
      </div>
      </div>
      <div v-if="index==3" >
        <div class="block14box">
        <div class="block_14 flex-row">
          <span class="text_20">07</span><span class="text_21">/10</span>
          <span class="text_22" style="margin-left: 120px">门墙柜</span>
          <div class="blocks_19 flex-row"></div>
          <div class="blocks_20 flex-row"></div>
          <div class="blocks_21 flex-row"></div>
        </div>
        <div class="block_14 flex-row" style="margin-top: 40px">
          <span class="text_20">08</span> <span class="text_21">/10</span>
          <span class="text_22" style="margin-left: 120px;margin-right: 60px">地暖</span>
          <div class="blocks_22 flex-row"></div>
          <div class="blocks_23 flex-row"></div>
          <div class="blocks_24 flex-row"></div>
        </div>
        </div>
      </div>
      <div v-if="index==4" >
        <div class="block14box">
        <div class="block_14 flex-row">
          <span class="text_20">09</span><span class="text_21">/10</span>
          <span class="text_22" style="margin-left: 120px">成品家具</span>
          <div class="blocks_25 flex-row"></div>
          <div class="blocks_26 flex-row"></div>
          <div class="blocks_27 flex-row"></div>
        </div>
        <div class="block_14 flex-row" style="margin-top: 40px">
          <span class="text_20">10</span> <span class="text_21">/10</span>
          <span class="text_22" style="margin-left: 120px">壁布窗帘</span>
          <div class="blocks_28 flex-row"></div>
          <div class="blocks_29 flex-row"></div>
          <div class="blocks_30 flex-row"></div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ProjectsList',
  data() {
    return {
      projects: [],
      index: 0,
      startX: null,
      startY: null,
    };
  },
  methods: {  // 新增触摸事件处理
    handleTouchStart(e) {
      this.startY = e.touches[0].clientY;
    },
    handleTouchEnd(e) {
      if (!this.startY) return;
      const endY = e.changedTouches[0].clientY;
      const deltaY = endY - this.startY;
      const deltaX = Math.abs(e.changedTouches[0].clientX - this.startX);

      // 垂直滑动距离大于30px且水平滑动小于50px时才触发
      if (Math.abs(deltaY) > 50 && deltaX < 400) {
        if (deltaY > 0) { // 向下滑动
          this.$router.push('/about.html'); // 跳转
        } else if (deltaY < 0) { // 向上滑动
          this.$router.push('/committee-list.html');
        }
      }
      this.startY = null;
    },
    handleWheelScroll(e) {
      if (e.ctrlKey || e.metaKey) return; // 过滤组合键操作

      if (e.deltaY > 0) { // 检测向下滚动
        this.$router.push('/committee-list.html');
      }else if (e.deltaY < 0) { // 检测向上滚动
        this.$router.push('/about.html'); // 跳转
      }
    },
    handleKeyDown(e) {
      // 阻止Ctrl+加号/减号/鼠标滚轮
      if ((e.ctrlKey === true || e.metaKey) &&
          (e.keyCode === 61 || e.keyCode === 107 ||
              e.keyCode === 173 || e.keyCode === 109 ||
              e.keyCode === 187  || e.keyCode === 189)) {
        e.preventDefault();
      }
    },
    handleWheel(e) {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
      }
    },
    handleTouchMove(e) {
      if (e.scale !== 1) {
        e.preventDefault();
      }
    },
    butLclick() {
      if (this.index >= 1) {
        this.index--;
      }else {
        this.index = 4
      }
    },
    butRclick() {
      if (this.index < 4) {
        this.index++;
      }else {
        this.index = 0;
        // this.$alert('已经是最后一页了', '提示', {  // 新增弹窗
        //   confirmButtonText: '确定'
        // });
        // this.index = 2;
      }
    },
  },
  mounted() {
    // 添加触摸事件监听
    document.addEventListener('touchstart', this.handleTouchStart, { passive: false });
    document.addEventListener('touchend', this.handleTouchEnd, { passive: false });
    // 添加滚轮事件监听
    window.addEventListener('wheel', this.handleWheelScroll);
    // 禁用快捷键缩放
    document.addEventListener('keydown', this.handleKeyDown);
    // 禁用双指缩放（移动端）
    document.addEventListener('wheel', this.handleWheel, { passive: false });
    // 禁用触摸事件缩放
    document.addEventListener('touchmove', this.handleTouchMove, { passive: false });
  },
  beforeUnmount() {
    // 移除触摸事件监听
    document.removeEventListener('touchstart', this.handleTouchStart);
    document.removeEventListener('touchend', this.handleTouchEnd);
    // 移除滚轮事件监听
    window.removeEventListener('wheel', this.handleWheelScroll);
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('wheel', this.handleWheel);
    document.removeEventListener('touchmove', this.handleTouchMove);
  },
  computed: {
    containerStyle() {
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: 'top left',
        width: `${100 / this.scale}%`,
        height: `${100 / this.scale}%`
      };
    }
  },
};
</script>
<style>
/* 新增移动端样式 */
@media (max-width: 768px) {
  .dbeijing{
    z-index: 0!important;
  }
  .box {

  }
  .hidden-column{
    display: flex !important;
  }
  .butL {
    position: absolute !important;
    top: 20% !important;
    margin-top: 20px !important;
    z-index: 999 !important;
    cursor: pointer;
    left: 65px !important;
  }
  .jiancailist {
    position: fixed;
    top: 28% !important;
    left: 49% !important;
    width: 100%!important;
    height: 100%!important;
    display: flex;
    transform: translateX(-50%) scale(0.40) !important;  /* 新增左移效果 */
  }
  .block_14 {
    display: flex;
    flex-direction: column !important;
    flex-wrap: nowrap !important;
    align-items: baseline;
    margin-top: 0px !important;
  }
  .block14box {
    display: flex;
    gap: 80px;
    justify-content: center
  }
  .blocks_16 {
    background-image: url(../assets/jiancaixuangou/cizhuan1.jpg);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 319px;
    height: 271px;
    margin: 21px 23px 0 80px !important;
  }

  .text_20 {
    display: inline-block !important;
    vertical-align: bottom !important;
    width: auto !important;
    margin-right: 4px !important;
  }

  .text_21 {
    vertical-align: bottom !important;
    width: auto !important;
    margin-top: 0 !important;
    display: none!important;
  }
}
.hidden-column {
  display: none;
}
.block_14 {
  display: flex;
  flex-direction: row;
}
.blocks_3 {
  background-image: url(../assets/jiancaixuangou/jiadian1.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 0;
}

.blocks_4 {
  background-image: url(../assets/jiancaixuangou/jiadian2.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}

.blocks_5 {
  background-image: url(../assets/jiancaixuangou/jiadian3.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}

.blocks_6 {
  background-image: url(../assets/jiancaixuangou/weiyu1.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}

.blocks_7 {
  background-image: url(../assets/jiancaixuangou/weiyu2.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}

.blocks_8 {
  background-image: url(../assets/jiancaixuangou/weiyu3.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}
.blocks_16 {
  background-image: url(../assets/jiancaixuangou/cizhuan1.jpg);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 0;
}

.blocks_17 {
  background-image: url(../assets/jiancaixuangou/cizhuan2.jpg);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}

.blocks_18 {
  background-image: url(../assets/jiancaixuangou/cizhuan3.jpg);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}
.blocks_19 {
  background-image: url(../assets/jiancaixuangou/menqianggui1.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 0;
}

.blocks_20 {
  background-image: url(../assets/jiancaixuangou/menqianggui2.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}

.blocks_21 {
  background-image: url(../assets/jiancaixuangou/menqianggui3.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}
.blocks_22 {
  background-image: url(../assets/jiancaixuangou/dinuan1.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 0;
}

.blocks_23 {
  background-image: url(../assets/jiancaixuangou/dinuan2.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}

.blocks_24 {
  background-image: url(../assets/jiancaixuangou/dinuan3.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}
.blocks_25 {
  background-image: url(../assets/jiancaixuangou/jiajv1.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 0;
}

.blocks_26 {
  background-image: url(../assets/jiancaixuangou/jiajv2.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}

.blocks_27 {
  background-image: url(../assets/jiancaixuangou/jiajv3.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}
.blocks_28 {
  background-image: url(../assets/jiancaixuangou/chuanglian1.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 0;
}

.blocks_29 {
  background-image: url(../assets/jiancaixuangou/chuanglian2.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}

.blocks_30 {
  background-image: url(../assets/jiancaixuangou/chuanglian3.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}
.block_6 {
  background-image: url(../assets/jiancaixuangou/jiancai1.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 0;
}

.block_7 {
  background-image: url(../assets/jiancaixuangou/jiancai2.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}

.block_8 {
  background-image: url(../assets/jiancaixuangou/jiancai3.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}

.block_19 {
  background-image: url(../assets/jiancaixuangou/menchuang1.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 0;
}

.block_20 {
  background-image: url(../assets/jiancaixuangou/menchuang2.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}

.block_21 {
  background-image: url(../assets/jiancaixuangou/menchuang3.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}

.blocks_0 {
  background-image: url(../assets/jiancaixuangou/dengjv1.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 0;
}

.blocks_1 {
  background-image: url(../assets/jiancaixuangou/dengjv2.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}

.blocks_2 {
  background-image: url(../assets/jiancaixuangou/dengjv3.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}

.blocks_6 {
  background-image: url(../assets/jiancaixuangou/weiyu1.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 0;
}

.blocks_7 {
  background-image: url(../assets/jiancaixuangou/weiyu2.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}
.blocks_8 {
  background-image: url(../assets/jiancaixuangou/weiyu3.webp);
  background-size: cover;
  background-position: center; /* 新增：保持居中 */
  background-repeat: no-repeat; /* 新增：禁止重复 */
  width: 319px;
  height: 271px;
  margin: 21px 23px 0 80px;
}
/*按钮位置*/
.butL {
  position: absolute;
  top: 20%;
  margin-top: -20px;
  z-index: 999;
  cursor: pointer;
  left: 265px;
}


.text_20 {
  width: 47px;
  height: 53px;
  overflow-wrap: break-word;
  color: white;
  font-size: 38px;
  font-family: AlibabaPuHuiTi-Heavy;
  font-weight: 900;
  text-align: right;
  white-space: nowrap;
  line-height: 53px; /* 新增：行高与高度一致 */
  vertical-align: middle; /* 新增：垂直居中 */
}

.text_21 {
  width: 21px;
  height: 17px;
  overflow-wrap: break-word;
  color: whitesmoke;
  font-size: 16px;
  font-family: AlibabaPuHuiTi-Regular;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 17px;
  margin-top: 27px; /* 修改：移除原有28px上边距 */
  vertical-align: middle; /* 新增：垂直居中 */
}
.text_22 {
  color: whitesmoke;
  font-size: 22px;
  margin-right: 40px;
  vertical-align: middle; /* 新增：垂直居中 */
  line-height: 53px; /* 新增：与最大高度元素对齐 */
}

</style>